(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
(() => {
  let timer;
  let endTime = 0;
  const stop = () => {
    endTime = 0;
    clearTimeout(timer);
  };
  const align = () => {
    if (window.location.hash !== '#bewertungen' || Date.now() > endTime) {
      stop();
      return;
    }
    const target = document.getElementById('bewertungen');
    if (target) {
      const margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      if (Math.abs(target.getBoundingClientRect().top - margin) > 2) {
        target.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
    }
    timer = setTimeout(align, 150);
  };
  const begin = () => {
    stop();
    if (window.location.hash !== '#bewertungen') return;
    endTime = Date.now() + 8000;
    align();
  };
  window.addEventListener('hashchange', begin);
  window.addEventListener('load', begin, { once: true });
  window.addEventListener('wheel', stop, { passive: true });
  window.addEventListener('touchstart', stop, { passive: true });
  window.addEventListener('keydown', stop);
  if (document.readyState === 'complete') begin();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joy-baehr-catalog"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('joy-baehr-catalog'))customElements.define('joy-baehr-catalog',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.querySelector('.jb-filter-panel').open=!matchMedia('(max-width:749px)').matches;this.form=this.querySelector('form');this.cards=Array.from(this.querySelectorAll('[data-price]'));this.form.addEventListener('submit',e=>e.preventDefault());this.addEventListener('input',()=>this.update());this.addEventListener('change',()=>this.update());this.form.addEventListener('reset',()=>requestAnimationFrame(()=>this.update()));this.update();}update(){const f=this.form.elements;const min=f.min.value===''?-Infinity:Number(f.min.value)*100;const max=f.max.value===''?Infinity:Number(f.max.value)*100;const list=this.querySelector('.jb-products');let count=0;const collator=new Intl.Collator(this.dataset.locale);this.cards.sort((a,b)=>{if(f.sort.value==='price-up')return +a.dataset.price-b.dataset.price;if(f.sort.value==='price-down')return +b.dataset.price-a.dataset.price;return collator.compare(a.dataset.title,b.dataset.title)*(f.sort.value==='za'?-1:1);}).forEach(c=>{c.hidden=!!((f.brand.value&&c.dataset.brand!==f.brand.value)||(f.availability.value&&c.dataset.availability!==f.availability.value)||(f.type.value&&c.dataset.type!==f.type.value)||(f.size.value&&!c.dataset.size.split(',').includes(f.size.value))||(f.volume.value&&c.dataset.volume!==f.volume.value)||+c.dataset.price<min||+c.dataset.price>max);if(!c.hidden)count++;list.append(c);});this.querySelector('[data-count]').textContent=count;this.querySelector('.jb-empty').hidden=count>0;}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joy-baehr-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('joy-brand-hero')) {
  customElements.define('joy-brand-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.viewport = this.querySelector('[data-brand-viewport]');
      this.slides = [...this.querySelectorAll('[data-brand-slide]')];
      this.tabs = [...this.querySelectorAll('[data-brand-index]')];
      this.counter = this.querySelector('[data-brand-counter]');
      this.pauseButton = this.querySelector('[data-brand-pause]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.playing = !this.reduced;
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.index = 0;
      this.querySelectorAll('[data-brand-direction]').forEach(button => button.addEventListener('click', () => { this.stop(); this.show(this.index + Number(button.dataset.brandDirection)); }));
      this.tabs.forEach(button => button.addEventListener('click', () => { this.stop(); this.show(Number(button.dataset.brandIndex)); }));
      this.pauseButton.addEventListener('click', () => { this.playing = !this.playing; if (this.playing) { this.focused = false; this.hovered = false; } this.syncTimer(); });
      this.addEventListener('pointerenter', () => { this.hovered = true; this.syncTimer(); });
      this.addEventListener('pointerleave', () => { this.hovered = false; this.syncTimer(); });
      this.addEventListener('focusin', () => { this.focused = true; this.syncTimer(); });
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.syncTimer(); });
      this.viewport.addEventListener('pointerdown', () => this.stop(), { passive: true });
      this.viewport.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.stop(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1)); }
      });
      this.viewport.addEventListener('scroll', () => {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update(Math.round(this.viewport.scrollLeft / this.viewport.clientWidth)));
      }, { passive: true });
      this.visibilityHandler = () => this.syncTimer();
      document.addEventListener('visibilitychange', this.visibilityHandler);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.syncTimer(); }, { threshold: .35 });
      this.observer.observe(this);
      this.update(0);
      this.syncTimer();
    }
    disconnectedCallback() { clearInterval(this.timer); this.observer?.disconnect(); document.removeEventListener('visibilitychange', this.visibilityHandler); if (this.frame) cancelAnimationFrame(this.frame); }
    stop() { this.playing = false; this.syncTimer(); }
    syncTimer() {
      clearInterval(this.timer);
      this.pauseButton.textContent = this.playing ? this.pauseButton.dataset.pause : this.pauseButton.dataset.play;
      this.pauseButton.setAttribute('aria-pressed', String(!this.playing));
      if (this.playing && this.visible && !this.hovered && !this.focused && !document.hidden) this.timer = setInterval(() => this.show(this.index + 1), 3000);
    }
    show(value) {
      const index = (value + this.slides.length) % this.slides.length;
      this.viewport.scrollTo({ left: index * this.viewport.clientWidth, behavior: this.reduced ? 'instant' : 'smooth' });
      this.update(index);
    }
    update(index) {
      const nextIndex = Math.max(0, Math.min(this.slides.length - 1, index));
      if (this.ready && nextIndex === this.index) return;
      this.ready = true;
      this.index = nextIndex;
      this.slides.forEach((slide, i) => { slide.toggleAttribute('inert', i !== this.index); slide.setAttribute('aria-hidden', String(i !== this.index)); });
      this.tabs.forEach((tab, i) => { tab.classList.toggle('is-selected', i === this.index); tab.setAttribute('aria-pressed', String(i === this.index)); });
      this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joy-baehr-preview"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-jb-filter]');if(!button)return;const section=button.closest('.jb-preview');section.querySelectorAll('[data-jb-filter]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));section.querySelectorAll('[data-jb-category]').forEach(card=>{card.hidden=button.dataset.jbFilter!=='all'&&card.dataset.jbCategory!==button.dataset.jbFilter;});});

  } catch(e) { console.error(e); }
})();
})();
